module.exports = __webpack_public_path__ + "img/CPT01.dc121ac3.svg";